// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Bulle_tooltip__3q_RK"};